/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupportLinkOnAzure
 */
export interface SupportLinkOnAzure {
    /**
     * 
     * @type {string}
     * @memberof SupportLinkOnAzure
     */
    header: string;
    /**
     * 
     * @type {boolean}
     * @memberof SupportLinkOnAzure
     */
    is_active: boolean;
    /**
     * 
     * @type {string}
     * @memberof SupportLinkOnAzure
     */
    link_type: string;
    /**
     * 
     * @type {string}
     * @memberof SupportLinkOnAzure
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SupportLinkOnAzure
     */
    section_type: string;
    /**
     * 
     * @type {string}
     * @memberof SupportLinkOnAzure
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof SupportLinkOnAzure
     */
    language_code: string;
    /**
     * 
     * @type {string}
     * @memberof SupportLinkOnAzure
     */
    object_type: string;
    /**
     * 
     * @type {string}
     * @memberof SupportLinkOnAzure
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SupportLinkOnAzure
     */
    _etag: string;
    /**
     * 
     * @type {number}
     * @memberof SupportLinkOnAzure
     */
    _ts: number;
}

/**
 * Check if a given object implements the SupportLinkOnAzure interface.
 */
export function instanceOfSupportLinkOnAzure(value: object): value is SupportLinkOnAzure {
    if (!('header' in value) || value['header'] === undefined) return false;
    if (!('is_active' in value) || value['is_active'] === undefined) return false;
    if (!('link_type' in value) || value['link_type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('section_type' in value) || value['section_type'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('language_code' in value) || value['language_code'] === undefined) return false;
    if (!('object_type' in value) || value['object_type'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('_etag' in value) || value['_etag'] === undefined) return false;
    if (!('_ts' in value) || value['_ts'] === undefined) return false;
    return true;
}

export function SupportLinkOnAzureFromJSON(json: any): SupportLinkOnAzure {
    return SupportLinkOnAzureFromJSONTyped(json, false);
}

export function SupportLinkOnAzureFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportLinkOnAzure {
    if (json == null) {
        return json;
    }
    return {
        
        'header': json['header'],
        'is_active': json['is_active'],
        'link_type': json['link_type'],
        'name': json['name'],
        'section_type': json['section_type'],
        'url': json['url'],
        'language_code': json['language_code'],
        'object_type': json['object_type'],
        'id': json['id'],
        '_etag': json['_etag'],
        '_ts': json['_ts'],
    };
}

export function SupportLinkOnAzureToJSON(json: any): SupportLinkOnAzure {
    return SupportLinkOnAzureToJSONTyped(json, false);
}

export function SupportLinkOnAzureToJSONTyped(value?: SupportLinkOnAzure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'header': value['header'],
        'is_active': value['is_active'],
        'link_type': value['link_type'],
        'name': value['name'],
        'section_type': value['section_type'],
        'url': value['url'],
        'language_code': value['language_code'],
        'object_type': value['object_type'],
        'id': value['id'],
        '_etag': value['_etag'],
        '_ts': value['_ts'],
    };
}

